import React, { useRef, useEffect } from 'react';
import * as constantsViewer from '../../constants';
import { Corner } from '../pieces/Corner';
import { useSpring, a } from 'react-spring-beta/three';
import { HookSuspension } from '../pieces/Suspension';

export const Corners = ({
  corners,
  cornersHeight,
  cabinetHeight,
  cabinetWidth,
  cabinetDepth,
  withHookSuspension = false,
  unselected = false,
}) => {
  return (
    <>
      <CornersWithoutHook
        corners={corners}
        cornersHeight={cornersHeight}
        cabinetHeight={cabinetHeight}
        cabinetWidth={cabinetWidth}
        cabinetDepth={cabinetDepth}
        unselected={unselected}
      />
      {withHookSuspension ? (
        <>
          <HookSuspension
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            corner={corners.filter(corner => corner.position === 'BL')[0]}
            unselected={unselected}
          />
          <HookSuspension
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            corner={corners.filter(corner => corner.position === 'BR')[0]}
            unselected={unselected}
          />
        </>
      ) : null}
    </>
  );
};

function CornersWithoutHook({
  corners,
  cornersHeight,
  cabinetHeight,
  cabinetWidth,
  cabinetDepth,
  unselected = false,
}) {
  const group = useRef();

  const [spring, set] = useSpring(() => ({
    position: getPositionCornersWithoutHook(cornersHeight, cabinetHeight),
    scale: getScaleCornersWithoutHook(cornersHeight),
    immediate: !constantsViewer.REACT_SPRING_ANIMATIONS_ACTIVE,
    config: constantsViewer.REACT_SPRING_ANIMATIONS_CONF,
  }));

  useEffect(() => {
    let self = group.current;
    if (self)
      set({
        position: getPositionCornersWithoutHook(cornersHeight, cabinetHeight),
        scale: getScaleCornersWithoutHook(cornersHeight),
      });
  });

  return (
    <a.group ref={group} scale={spring.scale} position={spring.position}>
      {corners.map(corner => {
        return (
          <Corner
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            corner={corner}
            unselected={unselected}
            key={corner.position}
          />
        );
      })}
    </a.group>
  );
}

function getPositionCornersWithoutHook(cornersHeight, cabinetHeight) {
  return [
    0,
    0.0056 * (cornersHeight - 450) + (cabinetHeight - cornersHeight) / 2,
    0,
  ];
}

function getScaleCornersWithoutHook(cornersHeight) {
  // 5.63 is exact difference with height of Model cabinet
  // Need set position because of difference with rendering
  return [1, (450 * (cornersHeight / 450) - 5.63) / 444.37, 1];
}
